import React, { useState, useEffect } from 'react'
import { Link, useParams  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';

function Editfeedback(){
    const apiUrl = API_URL;
    const [items, setItems]=useState([]);
    const [industryitems, setIndustryitems]=useState([]);
    const [adminaction, setAdminaction]=useState([]);
    const [feedbacks, setFeedbacks]=useState([]);
    const getParam = useParams();
    const getfeedbackid = getParam.feedbackid;
    const [successMessages, setSuccessMessages] = useState([]);
    const [selectedOptions, setSelectedOptions]=useState([]);
    
    useEffect(()=>{
        const getfeedback = async (e) => {
            try{
                const postData = {
                    feedback_id: getfeedbackid
                };
                const result = await fetch(`${apiUrl}/admin/viewfeedback`,{
                    method: "POST",
                    headers:{
                        "Content-Type":"application/json",
                        "Accept":"application/json"
                    },
                    body:JSON.stringify(postData)
                });
                const data = await result.json();
                if(data.status !== 200){
                    throw new Error('Data not found');
                }
                setIndustryitems(data.indarray);
                setItems(data.data[0]);
                setSelectedOptions(data.selectedData);
                setFeedbacks(data.data[0].text);
                setAdminaction(data.data[0].admin_action_need);
            }
            catch(error){
                console.error('Error ', error)
            }
        };
        getfeedback();
    }, []);

    const updateFeedback = async(e) => {
        e.preventDefault();
        try{
            const postData = {
                feedbackTitle: feedbacks,
                feedback_id: getfeedbackid,
                adminaction: adminaction,
                selectedIndustry: selectedOptions
            }
            const result = await fetch(`${apiUrl}/admin/updatefeedback`, {
                method: "POST",
                headers: {
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(postData)
            })
            const data = await result.json();
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }
        catch(error){
            console.log('Error: ', error)
        }
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        window.location.reload();
    }
    var curreadminVal = items.admin_action_need;
    if(curreadminVal == 'yes'){
        var adminOption = <select className="form-select col-sm-5 selectBox" onChange={(e)=>setAdminaction(e.target.value)}>
                                <option value="yes" className='active'>Yes</option>
                                <option value="no" className="active">No</option>                               
                            </select>
    }
    else{
        adminOption = <select className="form-select col-sm-5 selectBox" onChange={(e)=>setAdminaction(e.target.value)}>                                
                            <option value="no">No</option>
                            <option value="yes">Yes</option>
                        </select>
    }
    const handleOption = (e) => {
        var getValue = (e.target.value);
        if(selectedOptions.includes(getValue)){
            setSelectedOptions(selectedOptions.filter((data)=>data!=getValue));
        }else{
            setSelectedOptions([...selectedOptions, getValue]);
        }
    } 
    return (
        <div className='width90'>
            <h2 className='pageTitle'>Edit Feedback</h2>
            <div className='commonCntr'>
                <form className="form-horizontal" onSubmit={updateFeedback}>
                    <div className="form-group">
                        <label className="control-label col-sm-2 label" htmlFor="feedbacktitle">Feedback Title:</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" id="feedbacktitle" value={feedbacks} onChange={(e)=>setFeedbacks(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group mt-5">
                        <label className="control-label col-sm-2 label" htmlFor="permissiontype">Admin action:</label>
                        {adminOption}
                    </div>
                    <div className="form-group mt-5">
                        <label className="control-label col-sm-2 label" htmlFor="industrytype">Industry Type:</label>
                        <select multiple className="form-select col-sm-5 selectBox" value={selectedOptions} onChange={()=>{}}>                        
                            {industryitems.map((item, index) => {
                                return(<option value={item.id} onClick={handleOption}>{item.industry_name}</option>
                            )})}
                        </select>
                        {/* <p>Selected Options: {selectedOptions.join(', ')}</p> */}
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="submit" className="btn btn-default submitBtn">Submit</button>
                        </div>
                    </div>
                </form>
                {
                    successMessages.map((message, index) => (
                        <SuccessMessage
                            key={index} 
                            message = {message} 
                            onFadeOut={handleSuccessMessageFadeOut}
                        />
                    )
                )}
            </div>
        </div>
    )
}

export default Editfeedback;